import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify)


export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#AD2427',
        secondary: '#D34943',
        darkgrey: '#7C7D7D',
        error: '#b71c1c',
        background:'#F8F8F8',
        lsidebg: '#f7f9fd',//'#eff2f7',
        rsidebg: '#f5f3f2', //'#c86c54', //'#6b857f',
        navbg: '#f9edef',
        footergrey:'#d1c2c2',//'#eeedea',//'#d0d9da',#2a5ef3
        link:'#1d6be0',
        navlink:'#97394a',
        l_case:'#caf9eb',
        l_legis:'#ffedd3',
        l_other:'#d3daff',
        liiblack: '#402828',
        lightgrey:'#f4f2f2',
        anchor:'#1d6be0' ,

      },
    },
    options: { customProperties: true }
  },
});
